<template>
  <base-dialog-button :isOpen="dialogOpen" @closeDialog="toggleDialog" :size="sizeLg ? 'lg-fix-h' : 'md'" :ariaLabel="header">
    <template slot="header">
      <div class="h-16 bg-secondary flex items-center justify-between text-white px-4">
        <div class="flex items-center">
          <h2 class="font-bold ml-2">{{header}}</h2>
        </div>
        <span class="cursor-pointer" @click="toggleDialog">
          <base-button-icon name="cross" size="xs" iconSize="sm" mode="secondary" />
        </span>
      </div>
    </template>
    <template slot="main">
      <div 
        class="form-wrapper p-4 overflow-x-hidden"
        ref="containerSelect"
        style="max-height: 60vh"
        :style="{'height':heightContainerSelect}"
        >
        <el-form
          :model="form"
          ref="ruleForm"
          :rules="rules"
        >
            <div class="w-full mb-4 md:mb-0 ">
              <div v-if="(role === 'AdminDistribuidor' || role === 'SuperAdminDistribuidor' || role === 'SuperAdministrador')">

                <AccessibleElSelect
                  prop="idCliente"
                  v-model="form.idCliente"
                  :options="clientes.map(c => ({ id: c.IdEmpresa, name: c.Nombre }))"
                  id-prefix="importxml"
                >
                  <template #label>
                    <base-obligatory-icon/>{{$t('app.client')}}
                  </template>
                </AccessibleElSelect>

              </div>
            </div>
            <div class="mb-4" v-if="activateSwitchs">
              <label for="xml-import-rules-switch" class="text-sm font-semibold text-secondary-600 block mb-1">
                {{$t('app.excel_import_options')}}
                <span class="sr-only">{{$t('app.options')}}: {{$t('app.inactive')}} / {{$t('app.active')}}</span>
              </label>
              <div class="flex flex-col lg:flex-row lg:space-x-4">
                <el-switch 
                  id="xml-import-rules-switch"
                  :aria-label="$t('app.excel_import_options')"
                  class="switch-text break-normal both-switch mb-2 lg:mb-0" 
                  v-model="form.switch1" 
                  :active-text="$t('app.xml_import_options_rules')"/>
              </div>
            </div>
            <div class="mb-0 flex gap-x-6">
              <div class="w-full">
                <label class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon/>{{$t('app.xml_to_import')}}</label>
                <div class="flex justify-center w-full">
                  <el-form-item prop="files" ref="uploadexcel" class="mb-0">
                    <Upload
                      role="button"
                      ref="upload"
                      accept=".xml"
                      class="bg-white dark:bg-darkblue-900 "
                      :class="[isLower1024 ? 'custom-upload-cert' : 'custom-upload ']"
                      drag
                      action="#"
                      :show-file-list="true"
                      multiple
                      :limit="this.maxFiles"
                      :auto-upload=false
                      :on-remove="handleRemove"
                      :on-change="handleChange"
                      :on-exceed="handleOnExceed"
                      >
                      <i class="el-icon-upload"></i>
                      <p v-if="files && files.length" class="el-upload__text"><em>{{this.fileNames}}</em></p>
                      <div v-else class="el-upload__text">Suelta tus archivos aquí o <em>haz clic para cargar</em></div>
                    </Upload>
                  </el-form-item>
                </div>
                <div class="flex items-center gap-x-2 justify-center w-full mt-2">
                  <label class="text-sm text-secondary-600 block mb-1">{{$t('app.template_xml')}}</label>
                  <base-button-icon
                    ariaLabel="Descargar plantilla de importación"
                    @click="downloadTemplate"
                    size="xs"
                    name="download"
                    class="bg-primary-100 dark:bg-darkblue-800 dark:text-darkblue-200 rounded-full inline-block "
                  />
                </div>
              </div>
            </div>
          
        </el-form>
      </div>
    </template>
    <template slot="footer">
      <div class="w-full flex items-center gap-x-2">
        <base-button @click="toggleDialog" class="w-full" mode="secondary-phantom-blue" :text="$t('app.cancel')" />
        <base-button mode="secondary-phantom-blue" class="w-full" :text="$t('app.accept')" @click="apply('ruleForm')" />
      </div>
    </template>
  </base-dialog-button>
</template>

<script>
import BaseDialogButton from './base/BaseDialogButton.vue'
import { getClients } from '@/services/clients/getClients'
import { Upload } from 'element-ui'
import { i18n } from '@/i18n'
import AccessibleElSelect from '@/components/elementui/AccessibleElSelect.vue'

export default
{
  name: 'import-xml-dialog',
  components: {
    BaseDialogButton,
    Upload,
    AccessibleElSelect,
  },
  props: {
    vuexNamespace: {
      type: String,
      default: null
    },
    header: {
      type: String,
      default: 'Importante'
    },
    dialogOpen: {
      type: Boolean,
      default: false
    },
    secondaryTemplate: {
      type: Boolean,
      default: false
    },
    mandatoryClient: {
      type: Boolean,
      default: false
    },
    activateSwitchs: {
      type: Boolean,
      default: false
    },
    sizeLg: {
      type: Boolean,
      default: false
    },
    maxFiles: {
      type: Number,
      default: 50,
    }
  },
  data: function () {
    return {
      heightSelect: 0,
      heightInput: 64,
      isOpen: this.dialogOpen,
      files: [],
      form: {
        value: '',
        switch1: false,
        switch2: false,
        idCliente: null,
      },
      // maxFiles: 100,
      maxSizeFile: 104857600, // Bytes (100 MB) 
      msgTooltip: '',
      clientes: [],
      rules: {
        idCliente: [
          { validator: this.isGenericValidation, trigger: 'blur' },
          { validator: this.isGenericValidation, trigger: 'change' }
        ],
        files: [
          {
            message: this.$i18n.t('app.fill_data'),
            trigger: ['blur', 'change'],
            validator: (rule, value, callback) => {
              if (!this.fileNames) {
                this.doAriaLiveAndReturnCallback(i18n.t('validation.complete'), callback)
              } else {
                callback()
              }
            }
          },
          {
            message: this.$i18n.t('validation.not_xml'),
            trigger: ['blur', 'change'],
            validator: (rule, value, callback) => {
              let invalidExtension = false
              this.files.forEach(archivo => {
                if (archivo.name.length < 5 || archivo.name.substr(archivo.name.length - 4).toUpperCase() !== '.XML') {
                  invalidExtension = true
                }
              })
              if (invalidExtension) {
                this.doAriaLiveAndReturnCallback(i18n.t('validation.not_xml'), callback)
              } else {
                callback()
              }
            }
          },
          {
            required: true,
            message: this.$i18n.t('validation.exceed_size_files') + ' (' + this.maxMB + ' MB)',
            trigger: ['blur', 'change'],
            validator: (rule, value, callback) => {
              if (!this.fileNames && this.files.filter(x => x.size > this.maxSizeFile).length > 0) {
                this.doAriaLiveAndReturnCallback(i18n.t('validation.exceed_size_files'), callback)
              } else {
                callback()
              }
            }
          }
        ]
      }
    }
  },
  watch: {
    dialogOpen (value, oldValue) {
      this.form.idCliente = null
      this.files = []
      if (value) {
        this.loadClients()
      } else {
        this.clientes = []
      }
    }
  },
  mounted: async function () {
  },
  computed: {
    empresaFilter () {
      if (this.vuexNamespace && 
      (this.role === 'AdminDistribuidor' || this.role === 'SuperAdminDistribuidor' || this.role === 'SuperAdministrador')) {
        return this.$store.getters[this.vuexNamespace + '/getMasterFilters']?.empresa?.value || null
      }
      return null
    },
    canMultipleFiles () {
      return this.maxFiles > 1
    },
    maxMB () {
      return this.maxSizeFile / 1024 / 1024
    },
    heightContainerSelect: function () {
      if (this.heightSelect !== undefined && this.heightSelect !== 0) {
        let heightCalc = this.heightSelect + this.heightInput + 30
        if (heightCalc > 400) heightCalc = 400
        return heightCalc + 'px'
      } else {
        return 'auto'
      }
    },
    role: function () {
      return this.$store.getters['auth/role']
    },
    isLower1024: function () {
      return this.$store.getters['app/getIsLower1024']
    },
    fileNames () {
      if (this.files === null || this.files.length === 0) {
        return ''
      } else if (this.files.length === 1) {
        return this.files[0].name
      } else {
        return '(' + this.files.length + ') Archivos'
      }
    },
  },
  methods: {
    handleChange: function (file) {
      this.$refs.uploadexcel.clearValidate()
      this.files.push(file)
    },
    handleRemove: function (file) {
      this.files = this.files.filter(x => x.uid !== file.uid)
    },
    handleOnExceed: function () {
      this.doFeedback('Se ha superado el número máximo de ficheros (' + this.maxFiles + ')', 'warning')
    },
    loadClients: async function () {
      if (this.role === 'AdminDistribuidor' || this.role === 'SuperAdminDistribuidor' || this.role === 'SuperAdministrador') {
        const dataClients = await getClients()
        if (dataClients.blnError === true) {
          this.doFeedback(dataClients.msgError + ' [Código de error: ' + dataClients.codError + ']')
        }
        this.clientes = dataClients.Empresas
        if (this.empresaFilter) this.preSelectClient(this.form, 'idCliente')
      }
    },
    toggleDialog: function () {
      if (this.dialogOpen && this.isLoadingSelect) return
      this.isOpen = !this.isOpen
      this.$emit('toggleDialog')
    },
    apply: async function (ruleForm) {
      this.$refs[ruleForm].validate(async valid => {
        if (valid) {
          this.isOpen = !this.isOpen
          this.$emit('applyDialog', this.files, this.form)
        } else {
          this.doFeedback('Error al procesar los datos, revise la información')
        }
      })
    },
    downloadTemplate () {
      if (this.role !== 'Administrador' && this.mandatoryClient && !this.form.idCliente) {
        this.$refs.ruleForm.validateField('idCliente')
        this.doFeedback('Para descargar esta plantilla es necesario seleccionar un cliente, revise la información')
        return
      }
      if (this.mandatoryClient) {
        this.$emit('downloadTemplate', this.form.idCliente)
      } else {
        this.$emit('downloadTemplate')
      }
    },
  }
}
</script>
